import { gql } from '@apollo/client';

export const FP_OFFICES = gql`
    query getFrontpageOffices {
        getFrontpageOffices {
            id
            title
            description
            urltag
        }
    }
`;